import React from 'react';
import { faFile, faFileCircleCheck, faFolder, faFolderPlus } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import './FileDetailsView.css';
import { formatBytes } from '../../Utils/formaters';

const FileDetailsView = ({ files, selectedItems, onItemClick, onItemDoubleClick, onContainerClick, onDragStart, onDragOver, onDrop, onContainerDragOver, onContainerDrop }) => {

    const isSelected = (file) => selectedItems.some(x => x.id == file.id && x.type == file.type)

    const getFolderIcon = (type) => {
        if (type == 'folder') return faFolder;
        else if (type == 'file') return faFile;
        else if (type == 'sharedFolder') return faFolderPlus
        else if (type == 'sharedFile') return faFileCircleCheck
    }

    return (
        <div className='details-view-container' onClick={onContainerClick} onDragOver={onContainerDragOver} onDrop={onContainerDrop}>
            <table className="table table-hover">
                <thead>
                    <tr>
                        <th className='fit'></th>
                        <th>Name</th>
                        <th>Date Modified</th>
                        <th>Type</th>
                        <th>Size</th>
                    </tr>
                </thead>
                <tbody className='table-group-divider'>
                    {files.map(file => (
                        <tr 
                            key={file.type+file.id} 
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); onItemClick(e, file); }}
                            onDoubleClick={(e) => { e.preventDefault(); e.stopPropagation(); onItemDoubleClick(file); }}
                            draggable
                            onDragStart={(e) => onDragStart(e, file)}
                            onDragOver={(e) => onDragOver(e, file)}
                            onDrop={(e) => onDrop(e, file)}
                            className={isSelected(file) ? 'table-active' : ''}
                            title={file.fullPath}
                        >
                            <td className='fit'><FontAwesomeIcon className="text-info" icon={getFolderIcon(file.type)} /></td>
                            <td>{file.name}</td>
                            <td>{new Date(file.modifiedDate).toLocaleString()}</td>
                            <td>{file.type}</td>
                            <td>{formatBytes(file.size ?? 0)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default FileDetailsView;